import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs';
import { reduce } from 'lodash-es';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { FeatureFlagActions, featureFlagFeature, featureList } from '@store';
import { BuildEnvironment, FeatureFlag } from '@shared/models';
import { APP_ENV_CONFIG } from '@shared/services';
import { DetailsItemComponent } from '@shared/components';

@Component({
  templateUrl: './feature-flags.component.html',
  styleUrls: ['./feature-flags.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, DetailsItemComponent, RktButtonDirective],
})
export class FeatureFlagComponent {
  envConfig = inject(APP_ENV_CONFIG);

  activeModal = inject(ActiveModal);

  store = inject(Store);

  router = inject(Router);

  environmentList: BuildEnvironment[] = ['develop', 'qa', 'staging', 'sandbox', 'production'];

  featureFlagsBoolean$ = this.store.select(featureFlagFeature.selectFeatureFlagState).pipe(
    tap({
      next: (flags) => {
        this.featureFlagsModel = { ...flags };
      },
    }),
  );

  featureList = featureList;

  featureFlagsModel: FeatureFlag = {};

  onSave(): void {
    this.store.dispatch(FeatureFlagActions.setFeatureFlags({ featureFlags: this.featureFlagsModel }));
    this.activeModal.close();
    this.reloadPage();
  }

  onSwitch(key: string): void {
    this.featureFlagsModel[key] = !this.featureFlagsModel[key];
  }

  onEnvPresetClick(envName: BuildEnvironment): void {
    const featureFlags = reduce(
      featureList,
      (result: FeatureFlag, value, key) => {
        return { ...result, [key]: value.environments.includes(envName) };
      },
      {},
    );
    this.featureFlagsModel = featureFlags;
  }

  reloadPage(): void {
    window.location.reload();
  }
}
